import {
  initialState,
  Actions,
  State,
  NEW_PREJUDICIAL,
  NEW_PREJUDICIAL_SUCCESS,
  NEW_PREJUDICIAL_ERROR,
  RESET_NEW_PREJUDICIAL,
} from "../../types/prejudicial/new";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_PREJUDICIAL:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_PREJUDICIAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_PREJUDICIAL_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_PREJUDICIAL:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
